module.exports = __webpack_public_path__ + "assets/img/online_qq.e0a84b28.svg";